// src/components/templates/DetailPageTemplate.jsx
import { Link } from 'react-router-dom';
import { Inquiry } from '../../features/Inquiry/Inquiry';
import styles from './DetailPageTemplate.module.css';

/**
 * Props:
 *   eyebrow: string
 *   title: string
 *   intro: string
 *   hero?: { img?: string, alt?: string }
 *   sections: Array<{ heading: string, body?: string, bullets?: string[] }>
 *   ctaLabel: string
 *   serviceContext: string
 *   backHref?: string (default '/')
 *   backLabel?: string (default '← 홈으로')
 *   relatedLink?: { href: string, label: string }
 *   onInquirySubmit?: (payload) => void
 */
export function DetailPageTemplate({
  title,
  intro,
  hero,
  sections = [],
  ctaLabel,
  serviceContext,
  backHref = '/',
  backLabel = '돌아가기',
  relatedLink,
}) {
  return (
    <main className={styles.main}>
      <div className={styles.topBar}>
        <div className="wrap">
          <Link to={backHref} className={styles.back} aria-label={backLabel}>
            <svg
              className={styles.backIcon}
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M13 8H3M7 4L3 8l4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{backLabel}</span>
          </Link>
        </div>
      </div>

      <header className={styles.header}>
        <div className="wrap">
          <h1 className={styles.title}>{title}</h1>
          {intro && <p className={styles.intro}>{intro}</p>}
          <a href="#page-inquiry" className={styles.cta}>
            {ctaLabel}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      </header>

      {hero?.img && (
        <div className={styles.heroWrap}>
          <div className="wrap">
            <img src={hero.img} alt={hero.alt || ''} className={styles.heroImg} />
          </div>
        </div>
      )}

      <section className={styles.body}>
        <div className="wrap">
          {sections.map((s, i) => (
            <div key={i} className={styles.block}>
              <h2 className={styles.blockHeading}>{s.heading}</h2>
              {s.body && <p className={styles.blockBody}>{s.body}</p>}
              {s.bullets?.length > 0 && (
                <ul className={styles.bulletList}>
                  {s.bullets.map((b, j) => (
                    <li key={j} className={styles.bulletItem}>
                      <span className={styles.bulletDot} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
          {relatedLink && (
            <div className={styles.relatedWrap}>
              <Link to={relatedLink.href} className={styles.related}>
                {relatedLink.label}
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path
                    d="M3 8h10M9 4l4 4-4 4"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          )}
        </div>
      </section>

      <Inquiry inline serviceContext={serviceContext} />
    </main>
  );
}
